module.exports = __webpack_public_path__ + "img/dice-d20.ed08e0ae.svg";